// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27oG6","clinicsSelect":"styles_clinicsSelect__3Wh5D"};